import request from './request';

export default {
	async getPaymentMethods(query) {
		const res = await request.get(`/app/payment-methods?channel=${query}`, {});
		return res;
	}
};
